import { Authorization } from "@wingspanhq/wingspan-api-sdk";
import { getAdminSessionToken } from "../../services/sessionStorage";
import { tokenStore } from "./tokenStore";

class AccountAccessService {
  getImpersonationState() {
    const adminToken = getAdminSessionToken();

    // A v3 impersonation is always staff-minted, so it satisfies both flags on
    // its own.
    const isImpersonatedOnV3 = tokenStore.isImpersonating();

    return {
      isImpersonated: isImpersonatedOnV3 || !!adminToken,
      isImpersonatedByWingspanAdmin: isImpersonatedOnV3
    };
  }

  resolveAccess(accountId: string, allGrants: Authorization[]) {
    const { isImpersonated, isImpersonatedByWingspanAdmin } =
      this.getImpersonationState();

    const grantsForAccount = accountId
      ? allGrants.filter(grant => grant.grantorAccountId === accountId)
      : [];

    const hasGrants = grantsForAccount.length > 0;

    const scopes = Array.from(
      new Set(grantsForAccount.flatMap(grant => grant.scopes ?? []))
    );

    const hasFullAccess = isImpersonated || !hasGrants || scopes.includes("*");

    return {
      scopes,
      hasFullAccess,
      hasScope: (scope: string) =>
        hasFullAccess || scopes.some(item => item === scope),
      isImpersonated,
      isImpersonatedByWingspanAdmin
    };
  }
}

export const accountAccessService = new AccountAccessService();
